
import React from 'react';

const DashboardLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-white via-[#F0F9FF] to-[#E0F2FE]">
      <div className="flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-solid border-[#0EA5E9] border-t-transparent"></div>
        <div className="text-gray-800 font-medium text-lg bg-white px-6 py-4 rounded-md border border-[#0EA5E9]/20 shadow-md">Loading...</div>
      </div>
    </div>
  );
};

export default DashboardLoader;
